import { Component, Input } from "@angular/core";
import { IdexService } from "../../../../idex.service";
import { zDoxItem } from "../../../../shared/types";
import { Mail, MailAttachment } from "./mail-viewer.type";

@Component({
   selector: "app-mail-viewer",
   templateUrl: "./mail-viewer.component.html",
   styleUrls: ["./mail-viewer.component.css"],
})
export class MailViewerComponent {
   @Input() mail: Mail;
   @Input() doc: zDoxItem;

   constructor(private service: IdexService) {}

   protected openAttach(attachment: MailAttachment) {
      const url =
         this.service.url + "/attachment?id=" + this.doc.id + "&aid=" + attachment.id + "&token=" + this.service.user.token;
      window.open(url, attachment.id || this.doc.id);
   }

   protected linkify(s: string): string {
      if (!s) {
         return s;
      }
      const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
      // www. sans http:// or https://
      const pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      // Email addresses *** here I've changed the expression ***
      const emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
      return s
         .replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
         .replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
         .replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>');
   }
}
